import React, { useEffect, useState, useRef } from "react";
import './request-a-demo.scss';
import ReCAPTCHA from "react-google-recaptcha";
import { NavLink, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CAPTCHA_SITE_KEY } from "../../../config/config";
import {
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Box,
  Tooltip
} from "@mui/material";

import { FormValidation } from "../../../core/utility";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  PublicService,
  UserService,
  LocalService,
} from "../../../core/services";
import { connect } from "react-redux";
// import { Loading } from "../../../redux/action";
import Loading from '../../../components/loader/loading';

import OtpField from "../../../components/otp/otp";
import { CryptoJS } from "../../../core/utility";
import useBodyClass from "../../../hooks/useBodyClass";
import HeadingStyle from "../../../components/heading-style/heading-style";
import { CaptchaService } from "../../../core/services/captcha.service";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from 'react-toastify';
import { MenuPropsSelect } from "../../../core/utility/style";
import Footer from "../../../components/footer/footer";
import { Instagram, YouTube } from "@mui/icons-material";
import MaterialSymbol from "../../../components/icons/material-symbol";
import ContentLoading from "../../../components/loader/loading";
import * as gtUtil from "../../../core/utility"


const userService: UserService = new UserService();
const localService: LocalService = new LocalService();
interface ErrorTypes {
  status: boolean;
  message: string;
}

interface Props {
  loading: (data: any) => void;
}

const cryptoJS = new CryptoJS();
const publicService: PublicService = new PublicService();

const RequestDemo: React.FC<Props> = (props: Props) => {
  const formValidation = new FormValidation();
  const captchaService = new CaptchaService();

  const [loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [errorEmail, setErrorEmail] = useState<ErrorTypes>();
  const [errorMessage, setErrorMessage] = useState<ErrorTypes>();
  const [email, setEmail] = useState("");
  const [instagramUsername, setInstagramUsername] = useState("");
  const [youtubeChannel, setYoutubeChannel] = useState("");
  const [_industry, setIndustry] = useState<any>("");
  const [showotpBox, setOtpBox] = useState(false);
  const [phone, setPhone] = useState("");
  const [captchaToken, setCaptchaToken] = useState<any>("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(false);
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(true);
  const [timer, setTimer] = useState(60);
  const [isTimerDisabled, setIsTimerDisabled] = useState(true);
  const [isNumberDisabled, setIsNumberDisabled] = useState(false);
  const [showResendEdit, setShowResendEdit] = useState(false);
  const phoneRef = useRef<any>(null);



  // For Disabling ...........................

  const [disableWhatsappfield, setDisableWhatsAppField] = useState(true);


  // For Verification----------------------------------------------
  const [verifiedWAfield, setVerifiedWAfield] = useState(false);

  //validations
  const [errorwhatsapp, setErrorWhatsApp] = useState<ErrorTypes>();
  const [errorFullName, setErrorFullName] = useState<ErrorTypes>();

  const [errorUserType, setErrorUserType] = useState<ErrorTypes>();

  const navigate = useNavigate();


  //handles

  const handleFullName = (e: any) => {
    setErrorFullName(formValidation.GetNameValidate(e.target.value));
  };

  const handleEmail = (e: any) => {
    const value = e?.target?.value ?? e;
    setEmail(e.target.value)
    let isValid: { status: boolean; message: string } =
      formValidation.GetEmailControlIsValid(value);
    setErrorEmail(isValid);


  }

  useEffect(() => {
    let countdown: any;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setTimer(0);
      setIsResendButtonDisabled(false);
    }

    return () => clearInterval(countdown);
  }, [timer]);

  const handleSendOtpButton = (e: any) => {
    let isValid: any = formValidation.GetMobileControlIsValid(phone);
    // if (`${phone}`.length === 10){
    if (isValid.status) {
      setErrorWhatsApp(isValid);

      PublicService.sendOtp({ mobile: +phone, request_demo: "true" })
        .then((res: any) => {
          if (res.status === gtUtil.Constants.SUCCESS) {
            setIsNumberDisabled(true);
            setShowResendEdit(true);
            setIsResendButtonDisabled(true);
            setTimer(30);
            setIsTimerDisabled(true);
            setIsEditButtonDisabled(true);
            setOtpBox(res.status === gtUtil.Constants.SUCCESS);
            setDisableWhatsAppField(res.status === gtUtil.Constants.SUCCESS);
            localService.toastify(res.info, "success", 1000);
          } else {
            localService.toastify(res.info, "error", 1000);
          }
          // setLoading(false);
        })
        .catch((error: any) => {
          // setLoading(false);
          console.warn(`Otp Response Error :: ${error}`);
        });
    } else {
      setErrorWhatsApp(isValid);
    }
  }
  
  // const handleWhatsApp = (e: any) => {
  //   setErrorWhatsApp(formValidation.GetMobileControlIsValid(e.target.value));
  // }
  const handleWhatsAppOtp = (otp: any) => {
    if (otp.length === 4) {
      PublicService.verifyOtp({ mobile: +phone, otp: otp })
        .then((res) => {
          if (res.status === gtUtil.Constants.SUCCESS) {
            setOtpBox(false);
            setDisableWhatsAppField(true);
            setShowResendEdit(false);
            setVerifiedWAfield(true);
            setIsNumberDisabled(true);
            localService.toastify(res.info, "success", 1000);
          } else {
            localService.toastify(res.info, "error", 1000);
          }
        })
        .catch((error) => {
          throw new Error("VerifyOtp Error ::: " + error);
        });
    }
  }

  // const submitRequestDemo = async (storeData: any) => {
  //   const response = await publicService.requestADemo(storeData)
  //   localService.toastify(response.data.rows.message);
  //   if (response.data.rows.status) {
  //     navigate('/');
  //   }else{
  //     navigate('/')
  //   }
  // }/

  const submitRequestDemo = async (storeData: any) => {
    setLoading(true);
    try {
      const response = await publicService.requestADemo(storeData);
      localService.toastify(response.data.rows.message);
      
      if (response.data.rows.status) {
        window.history.back();
      } else {
        navigate('/');
      }
    } catch (error) {
      console.error("An error occurred:", error);
      localService.toastify("There was an issue submitting your request.");
    } finally {
      setLoading(false);
    }
  };

  let influencerTp : boolean 
  if (purpose === 'influencer_contact_us') {
    influencerTp = true
  } else {
    influencerTp = false
  }  

  const handleOnSubmit = async (e: any) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      const data = Object.fromEntries(form);
      const storeData: any = { message, phone, ...data };
      setErrorEmail(formValidation.GetEmailControlIsValid(`${email}`));
      setErrorFullName(formValidation.GetNameValidate(`${name}`));
      setErrorMessage(formValidation.GetLongTextValidate(`${message}`))
      setErrorUserType(formValidation.GetNameValidate(`${purpose}`))
      setErrorWhatsApp(
        formValidation.GetMobileControlIsValid(`${phone}`)
      );
      // For Validation
      const isValidEmail = formValidation.GetEmailControlIsValid(`${email}`).status
      const isValidName = formValidation.GetNameValidate(`${name}`).status;
      const isValidMessage = formValidation.GetLongTextValidate(`${message}`).status;
      const isValidUser = formValidation.GetNameValidate(`${purpose}`).status

      // Validate that either Instagram or YouTube is provided
      const isInstagramProvided = !!instagramUsername.trim();
      const isYouTubeProvided = !!youtubeChannel.trim();

      // Check if all fields are empty
      const areAllFieldsEmpty = !email && !name && !message  && !phone;
      
      // if all fields are empty
      if (areAllFieldsEmpty) {
        localService.toastify("All fields are required.", "error", 1000);
        return;
      }

      if (influencerTp) {
        if (!isInstagramProvided && !isYouTubeProvided) {
          localService.toastify(
            "Please provide either an Instagram handle or a YouTube channel.",
            "error",
            1000
          );
          return;
        }
      }

      // Check if CAPTCHA is verified
      if (!captchaToken) {
        localService.toastify("Please complete CAPTCHA verification.", "error", 1000);
        return;
      }

      if (!verifiedWAfield) {
        localService.toastify("Please verify your WhatsApp number by entering the OTP.", "error", 1000);
        return;
      }
      
      if (!disableWhatsappfield && phone) {
        localService.toastify("WhatsApp No. Not Verified.", "error", 1000);
      }
      else {
        props.loading(false);
      }
      const verifyCaptcha = async () => {
        try {
          const res = await captchaService.verifyCaptcha({ token: captchaToken });
          if (res?.data?.rows?.message === "Captcha verified successfully!"){
            return true;
          } else {
            setCaptchaToken("");
            return false;
          }
        } catch (error) {
          setCaptchaToken("");
          console.error(`verifyCaptcha Error :: ${JSON.stringify(error)}`);
          return false;
        }
      };
      if (await verifyCaptcha) {
        if (
          isValidName &&
          isValidEmail &&
          isValidMessage &&
          isValidUser &&
          disableWhatsappfield) {
          submitRequestDemo(storeData)
        }
      } else {
        localService.toastify("Please complete CAPTCHA verification.", "error", 1000);
      }

    }
    catch (error) {
    }
  };

  const handleChangePhone = () => {
    setVerifiedWAfield(false);
    setOtpBox(false);
    setShowResendEdit(false);
    setIsNumberDisabled(false);
    if (phoneRef.current) {
      phoneRef.current.focus();
    }
  }

  useBodyClass("common-signup-page");
  useBodyClass("request-a-demo-page");
  return (
    <>
      {
        loading 
        ? 
        (
          <div style={{height:'100vh', display:'flex',justifyContent:'center', alignItems:'center'}}><ContentLoading width='150' height='150' /></div>
        )
        :
        (
          <div className="_influencer-container">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-6 col-md-12 col-sm-12 col-12">

                  <div className="_influencer-signup">
                    <div className="row ">
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12 mt-1 mb-2 __backArrow">
                        <HeadingStyle title="Request a Demo" />
                      </div>
                    </div>

                    <form onSubmit={handleOnSubmit} className="__signup_form">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mt-1 mb-3">
                          <FormControl fullWidth size="small" className="input-style">
                            <InputLabel id="demo-simple-select-label">
                              I am
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="purposeId"
                              value={purpose}
                              label="Please Select One"
                              name="purpose"
                              onChange={(e) => setPurpose(e.target.value)}
                              MenuProps={MenuPropsSelect}
                            >
                              <MenuItem value="brand_request_demo">Brand/Advertiser</MenuItem>
                              <MenuItem value="influencer_contact_us">Influencer/Talent Partner</MenuItem>
                            </Select>
                          </FormControl>
                          <span className="error">{errorUserType?.message}</span>
                          {
                            influencerTp && <p className="m-0"><small>The demo is exclusively for Brands and Advertisers. If you still wish to reach out, please fill in your details and share your concern below.</small></p>
                          }
                        </div>
                        <div className="mb-3 row pe-0" >
                          <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-3 mb-sm-3 mb-md-0 mb-lg-0 pe-0 pe-sm-0 pe-md-0">
                            <TextField
                              className="w-100"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              id="full_name_id"
                              onBlur={handleFullName}
                              name="name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              placeholder="Full Name"
                              label="Name"
                              variant="outlined"
                            />
                            <span className="error">{errorFullName?.message}</span>
                          </div>
                          <div className="col-lg-6 col-md-6 pe-0">
                            <TextField
                              className="w-100"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              id="email_id"
                              // onBlur={handleEmail}
                              onChange={handleEmail}
                              name="email"
                              label="Your Email Id"
                              placeholder="Email Id"
                              variant="outlined"
                            />
                            <span className="error">{errorEmail?.message}</span>
                          </div>
                        </div>
                        <div className={`row pe-0 ${influencerTp ? 'mb-3' : ''}`}>
                          {influencerTp && (
                            <div className="row">
                              <div className="col-12 mb-1">
                                <p
                                  style={{
                                    margin: `0px`,
                                    marginBottom: "10px",
                                    fontSize: "14px",
                                  }}
                                >
                                  Social Media Handle (atleast one)
                                  <span style={{ color: `red` }}>*</span><br />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#888",
                                    }}
                                  >
                                    Please ensure the profiles mentioned belong to you and
                                    is genuine.
                                  </span>
                                </p>
                              </div>
                            </div>
                          )}
                          {influencerTp &&
                            <div className="col-lg-6 col-md-6  mb-3 mb-sm-3 mb-md-0 mb-lg-0 pe-0 pe-sm-0 pe-md-0 __wa_column">
                              <TextField
                                className="w-100 input-style"
                                name="instagram_handle"
                                value={instagramUsername}
                                onChange={(e) => setInstagramUsername(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Instagram />
                                    </InputAdornment>
                                  ),
                                }}
                                size="small"
                                id="instagram_id"
                                placeholder="eg. virat.kohli"
                                label="Instagram Handle/URL"
                                variant="outlined"
                              />
                            </div>
                          }
                          {influencerTp &&
                            <div className="col-lg-6 col-md-6 pe-0 __wa_column">
                              <TextField
                                className="w-100 input-style"
                                name="youtube_channel"
                                size="small"
                                id="youtube_id"
                                label="YouTube Channel/URL"
                                value={youtubeChannel}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <YouTube style={{ color: "red" }} />
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder="eg. UCjOooOPRBat1IqsP-BBPTzQ"
                                variant="outlined"
                                onChange={(e) => setYoutubeChannel(e.target.value)}
                              />
                            </div>
                          }
                        </div>
                        <div className=" mb-3">
                          <div className="col __wa_column">
                            <TextField
                              disabled={isNumberDisabled}
                              className="w-100"
                              type="number"
                              size="small"
                              color="primary"
                              inputRef={phoneRef}
                              // onBlur={handleWhatsApp}
                              name="phone"
                              id="whatsappnumber_id"
                              label="WhatsApp No."
                              value={phone}
                              InputProps={{
                                readOnly: verifiedWAfield,
                                startAdornment: (<InputAdornment position="start"><span className="fs-14 font-weight-normal">+91</span></InputAdornment>),
                              }}
                              onChange={(e) => {
                                // Restrict input to 10 digits
                                if (e.target.value.length <= 10) {
                                  setPhone(e.target.value);
                                  setDisableWhatsAppField(e.target.value.length !== 10);
                                }
                              }}
                              variant="outlined"
                            />
                            {!verifiedWAfield 
                              ? 
                              (
                                <LoadingButton
                                  className={disableWhatsappfield ? "btn btn-disabled __button send-otp" : "__button send-otp"}
                                  color="success"
                                  loadingPosition="start"
                                  disabled={disableWhatsappfield}
                                  onClick={handleSendOtpButton}
                                  variant="contained"
                                  startIcon={<WhatsAppIcon />}
                                >
                                  Send OTP
                                </LoadingButton>
                              ) 
                              : 
                              (
                                <Tooltip className="icon-verified" title="Verified" arrow>
                                  <IconButton size="small" className="p-0">
                                    <MaterialSymbol iconName="verified" fontweight="200" />
                                  </IconButton>
                                </Tooltip>
                              )
                            }
                            <span className="error">{errorwhatsapp?.message}</span>
                            {showResendEdit &&
                              <div className="resend-otp">
                                {isEditButtonDisabled && <p className="change-phone fs-12 btn btn-text-link" onClick={handleChangePhone}>Change Phone</p>}
                                <div className="resend-otp-container">
                                  <button
                                    className="otp-btn fs-12 btn btn-text-link"
                                    onClick={handleSendOtpButton}
                                    type="button"
                                    disabled={isResendButtonDisabled}
                                  >
                                    Resend OTP
                                  </button>
                                  {isTimerDisabled && <p className="otp-time fs-12">&nbsp; 00:{timer < 10 ? `0${timer}` : timer}</p>}
                                </div>

                              </div>
                            }

                            {showotpBox && <OtpField handleOtp={handleWhatsAppOtp} />}
                          </div>
                        </div>
                      </div>
                      <Box
                        component="form"
                        sx={{
                          '& .MuiTextField-root': { m: 1, width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <div className="mb-3">
                          <TextField
                            id="outlined-multiline-static "
                            className="textfield-message"
                            label="Message"
                            multiline
                            rows={4}
                            name="message"
                            value={message}
                            onChange={(e) => {
                              setMessage(e.target.value)
                            }}
                          />
                          <span className="error">{errorMessage?.message}</span>
                        </div>
                      </Box>
                      <div className="row mb-3">
                        <div className="col">
                          <ReCAPTCHA
                            sitekey={CAPTCHA_SITE_KEY}
                            onChange={(token: any) => setCaptchaToken(token)}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col text-end">
                          <LoadingButton
                            className="btn btn-primary ms-2"
                            type="submit"
                            loading={loading}
                            disabled={loading}
                            loadingPosition="start"
                            variant="contained"
                          >
                            Submit
                          </LoadingButton>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      <Footer />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(null, mapDispatchToProps)(RequestDemo);
export { connectToRedux as RequestDemo };
